import React from 'react';
import Desktop from './Desktop';
import Mobile from './Mobile';

const TableList = (props) => {
    return <>
        <Desktop {...props} />
        <Mobile {...props} />
    </>
}


export { Desktop, Mobile, TableList }